import { render } from "./VistaDetalle.vue?vue&type=template&id=65312113&scoped=true&ts=true"
import script from "./VistaDetalle.vue?vue&type=script&lang=ts"
export * from "./VistaDetalle.vue?vue&type=script&lang=ts"

import "./VistaDetalle.vue?vue&type=style&index=0&id=65312113&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65312113"]])

export default __exports__